module.exports = __webpack_public_path__ + "assets/niunai.9d09d8da.svg";